import type { Metadata } from "next";
import { ORG } from "@/content/_site.config";
import type { Key, PageSpecBase } from "@/content/types";

export function metadataFromSpec<K extends Key = "">(
  { seo: { canonical, title, description }, hero, ...rest }: PageSpecBase<K>,
  key?: K,
): Metadata {
  const url = canonical ?? `${ORG.url}${rest.slug}`;

  const { publicId, alt } =
    typeof hero === "function" ? hero(key ?? ("" as K)) : hero;

  return {
    title,
    description,
    alternates: { canonical: url },
    openGraph: {
      url,
      title,
      description,
      images: publicId ? [{ url: publicId, alt }] : undefined,
    },
    twitter: {
      title,
      description,
      card: publicId ? "summary_large_image" : "summary",
      images: publicId ? [publicId] : undefined,
    },
  };
}
